<template>
  <div class="case-confirm-dailog dialog col-block width-full">
    <template>
      <div class="main-container case col-block width-full">
        <div class="form-block col-block width-full">
          <customForm
            :init="caseData"
            :layoutType="'grid'"
            :groupCount="6"
            :forms="formOptions['field1']"
            :reading="true"
            :titleSmallInterval="true"
            @change="() => {}"
          ></customForm>
        </div>
      </div>
    </template>
    <template>
      <hr class="custom full" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' }">
      <div class="main-container analysis col-block width-full">
        <div class="form-block col-block width-full">
          <customForm
            :init="analysisData"
            :layoutType="'grid'"
            :groupCount="6"
            :forms="formOptions['field2']"
            :reading="true"
            :titleSmallInterval="true"
            @change="() => {}"
          ></customForm>
        </div>
        <div class="form-block col-block width-full">
          <customForm
            :init="analysisData"
            :layoutType="'grid'"
            :groupCount="6"
            :forms="formOptions['field3']"
            :reading="true"
            :titleSmallInterval="true"
            @change="() => {}"
          >
            <template slot="PHENOTYPE" slot-scope="props">
              <div class="PHENOTYPE-container col-block flex-start" :name="props">
                <template v-if="analysisData.phenotypes">
                  <template v-for="(key, kindex) in Object.keys(analysisData.phenotypes)">
                    <div v-for="(data, dindex) in analysisData.phenotypes[key]" :key="kindex + '_' + dindex">{{ data.query }}</div>
                  </template>
                </template>
                <div v-else>- -</div>
              </div>
            </template>
            <template slot="GENE_PANEL" slot-scope="props">
              <div class="GENE_PANEL-container col-block flex-start" :name="props">
                <template v-if="analysisData.gene_panels">
                  <div v-for="(data, dindex) in analysisData.gene_panels" :key="dindex">{{ data.name }}</div>
                </template>
                <div v-else>- -</div>
              </div>
            </template>
            <template slot="AFT" slot-scope="props">
              <div class="AFT-container col-block width-full" :name="props" :style="{ 'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr' }">
                <div
                  v-for="(option, oindex) in AFTOptions"
                  :key="oindex"
                  :style="{ 'grid-column': 'span ' + option.grid + ' / auto' }"
                >{{ option.title + (option.operator || ' =') + ' ' }}<span :style="(option.style || (() => ({})))(option.value(analysisData))">{{ (option.display || (x => x))(option.value(analysisData)) }}</span></div>
              </div>
            </template>
            <template slot="ST" slot-scope="props">
              <div class="ST-container col-block width-full" :name="props" :style="{ 'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr' }">
                <div
                  v-for="(option, oindex) in STOptions"
                  :key="oindex"
                  :style="{ 'grid-column': 'span ' + option.grid + ' / auto' }"
                >{{ option.title + (option.operator || ' =') + ' ' }}<span :style="(option.style || (() => ({})))(option.value(analysisData))">{{ (option.display || (x => x))(option.value(analysisData)) }}</span></div>
              </div>
            </template>
          </customForm>
        </div>
      </div>
    </template>
    <template v-if="fileSets.length || caseData.omics_name">
      <hr class="custom full" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' }">
      <div class="main-container file col-block width-full">
        <div class="main-title">{{ { 'vcf': 'VCF', 'fastq': 'FASTQ' }[caseData.dataset] + ' Dataset'/* ___ */ }}</div>
        <div class="file-field row-block" :style="{ 'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr' }">
          <div v-if="caseData.dataset === 'fastq'" class="pipeline-container col-block" :style="{ 'grid-column': 'span 2 / auto' }">
            <div class="main-title">{{ 'Pipeline'/* ___ */ }}</div>
            <div :style="{ height: '8px' }"></div>
            <div v-html="[caseData.omics_name, caseData.pipeline_name, caseData.library_type_name].filter(x => x).join(',<br>')"></div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="set-container col-block" :style="{ 'grid-column': 'span 4 / auto' }">
            <div class="set-block row-block" v-for="(set, index) in fileSets" :key="index">
              <template v-if="caseData.dataset === 'vcf'">
                <div class="file-block" :style="{ flex: 1 }">
                  <div class="file-title">{{ 'VCF File'/* ___ */ }}</div>
                  <div :style="{ height: '5px' }"></div>
                  <div class="file-source ellipsis">{{ set.vcf.name }}</div>
                </div>
              </template>
              <template v-if="caseData.dataset === 'fastq'">
                <div class="file-block" :style="{ flex: 1 }">
                  <div class="file-title">{{ 'Set' + (index + 1) + '-Fastq-R1'/* ___ */ }}</div>
                  <div :style="{ height: '5px' }"></div>
                  <div class="file-source ellipsis">{{ set.r1.name }}</div>
                </div>
                <div :style="{ width: '16px' }"></div>
                <div class="file-block" :style="{ flex: 1 }">
                  <div class="file-title">{{ 'Set' + (index + 1) + '-Fastq-R1'/* ___ */ }}</div>
                  <div :style="{ height: '5px' }"></div>
                  <div class="file-source ellipsis">{{ set.r2.name }}</div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Cancel'/* ___ */ }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" @click="e => checkAlerts()">
        <span>{{ 'Create'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import customForm from '../../components/tool/customForm'

export default {
  components: {
    customForm
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    caseData () {
      return this.param.caseData
    },
    analysisData () {
      return this.caseData.project
    },
    fileSets () {
      return this.param.fileSets
    },
    // static
    formOptions () {
      return {
        'field1': [
          // 1
          {
            title: 'Case ID'/* ___ */,
            value: 'case_id',
            type: 'text',
            wrap: true,
            grid: 2
          },
          {
            title: 'Sample type'/* ___ */,
            value: 'affected',
            type: 'text',
            wrap: true,
            grid: 1,
            style: {
              'true': { color: '#83C91E' },
              'false': { color: '#999999' }
            }[this.caseData.affected + ''],
            inputFormat: value => ({
              'true': 'Affected'/* ___ */,
              'false': 'Unaffected'/* ___ */
            }[value + ''])
          },
          {
            title: 'Name'/* ___ */,
            value: 'subject_name',
            type: 'text',
            wrap: true,
            grid: 1
          },
          {
            title: 'Sex'/* ___ */,
            value: 'sex',
            type: 'text',
            wrap: true,
            grid: 1,
            style: {
              Male: { color: '#003679' },
              Female: { color: '#FA3D3D' },
              Unknown: { color: '#333333' }
            }[this.caseData.sex],
            inputFormat: value => ({ Male: 'Male', Female: 'Female', Unknown: 'Unknown' }[value])
          },
          {
            title: 'Birth Year'/* ___ */,
            value: 'birth_year',
            type: 'text',
            wrap: true,
            grid: 1,
            inputFormat: value => value || 'Unknown'
          },
          // 2
          {
            title: 'Population'/* ___ */,
            value: 'population',
            type: 'text',
            wrap: true,
            grid: 2,
            inputFormat: value => value || '--'
          },
          {
            title: 'Note'/* ___ */,
            value: 'note',
            type: 'text',
            wrap: true,
            grid: 4,
            inputFormat: value => value || '--'
          }
        ],
        'field2': [
          {
            title: 'Analysis Name'/* ___ */,
            value: 'name',
            type: 'text',
            wrap: true,
            grid: 2
          },
          {
            title: 'Analysis note'/* ___ */,
            value: 'note',
            type: 'text',
            wrap: true,
            grid: 3,
            inputFormat: value => value || '--'
          },
          {
            title: 'Report to PhenoVarDB'/* ___ */,
            value: 'report_phenovardb',
            type: 'text',
            wrap: true,
            grid: 1,
            style: {
              'true': { color: '#83C91E' },
              'false': { color: '#999999' }
            }[this.analysisData.report_phenovardb + ''],
            inputFormat: value => ({
              'true': 'On'/* ___ */,
              'false': 'Off'/* ___ */
            }[value + ''])
          }
        ],
        'field3': [
          // 1
          {
            title: 'Phenotype'/* ___ */,
            value: 'PHENOTYPE',
            type: 'custom',
            wrap: true,
            grid: 3
          },
          {
            title: 'Gene Panel'/* ___ */,
            value: 'GENE_PANEL',
            type: 'custom',
            grid: 3
          },
          // 2
          {
            title: 'Allele frequency threshold for inheritance modes'/* ___ */,
            value: 'AFT',
            type: 'custom',
            grid: 6
          },
          // 3
          {
            title: 'Score threshold for phenotype gene selection'/* ___ */,
            value: 'ST',
            type: 'custom',
            grid: 6
          }
        ]
      }
    },
    AFTOptions () {
      return [
        // 1
        {
          title: 'AD'/* ___ */,
          value: data => data.ad_cutoff,
          grid: 1
        },
        {
          title: 'AR'/* ___ */,
          value: data => data.ar_cutoff,
          grid: 1
        },
        {
          title: 'Exclude LQ variants'/* ___ */,
          value: data => data.exclude_low_quality_variants,
          grid: 4,
          style: value => ({
            'true': { color: '#006ED6' },
            'false': { color: '#999999' }
          }[value + '']),
          display: value => ({
            'true': 'ON'/* ___ */,
            'false': 'OFF'/* ___ */
          }[value + ''])
        },
        // 2
        {
          title: 'Compound heterozygosity'/* ___ */,
          value: data => data.comp_het_cutoff,
          grid: 2
        },
        {
          title: 'Lower priority for known benign variants'/* ___ */,
          value: data => data.enable_clinvar_benign_filter,
          grid: 4,
          style: value => ({
            'true': { color: '#006ED6' },
            'false': { color: '#999999' }
          }[value + '']),
          display: value => ({
            'true': 'ON'/* ___ */,
            'false': 'OFF'/* ___ */
          }[value + ''])
        }
      ]
    },
    STOptions () {
      return [
        {
          title: 'Phenotype score'/* ___ */,
          value: data => data.phenotype_score_cutoff,
          grid: 2
        },
        {
          title: 'Variant score'/* ___ */,
          value: data => data.variant_score_cutoff,
          grid: 2
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'setModal2Action'
    ]),
    async checkAlerts () {
      if (['Unknown'].includes(this.caseData.sex)) {
        if (!(await this.unknownSexAlert())) return
      }
      this.$emit('changeModal', {}, true)
    },
    async unknownSexAlert () {
      return new Promise(resolve => {
        this.setModal2Action({
          action: 'toast',
          width: '496px',
          customStyles: {
            padding: 0,
            border: 0
          },
          param: {
            type: 'alert',
            content: '<span style="color:#FA3D3D">Unknown sex may affect subsequent analysis results. Would you like to continue?</span>'/* ___ */,
            buttons: [
              {
                title: 'Cancel'/* ___ */,
                type: 'gray',
                result: false
              },
              {
                title: 'Create'/* ___ */,
                type: 'alert',
                result: true
              }
            ]
          },
          callback: async result => {
            resolve(result)
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseConfirm.vue